import React from 'react';
import { Box, Button, Collapse, Typography } from '@mui/material';

const JustificativasDropdown = ({ fornecedor, colunaReferencia }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '800px',
      }}
    >
      <Button
        variant="contained"
        size="large"
        onClick={() => setIsOpen(!isOpen)}
        sx={{
          width: '100%',
          backgroundColor: '#f40059',
          '&:hover': {
            backgroundColor: '#d40059',
          },
        }}
      >
        Justificativas Anteriores{/* {fornecedor && ( <span>Justificativas Anteriores</span>)} */}
      </Button>

      <Collapse in={isOpen}>
        <Box
          sx={{
            border: '1px solid #ccc',
            borderRadius: '2px',
            padding: '12px 16px',
            maxHeight: '150px',
            overflowY: 'auto',
            backgroundColor: '#fafafa',
            width: '100%',
          }}
        >
          {(fornecedor?.justificativas || [])
            .filter((j) => j.colunaReferencia === colunaReferencia)
            .map((j, index) => (
              <Typography
                key={index}
                variant="body2"
                sx={{ marginBottom: '8px', color: 'red' }}
              >
                {j.createdAt && (
                  <>
                    Negado:{' '}
                    {`${j.createdAt.split('T')[0].split('-').reverse().join('/')} às ${j.createdAt
                      .split('T')[1]
                      .slice(0, 5)}h`}
                    <br />
                  </>
                )}
                <span style={{ color: 'darkgray' }}>{j.descricao}</span>
              </Typography>
            ))}
        </Box>
      </Collapse>
    </Box>
  );
};

export default JustificativasDropdown;